import React, { FC } from 'react';
import { TreeSelect } from 'antd';
import { TreeNode } from 'antd/lib/tree-select';
import { TextbookSearchSubjectsType } from '../../pages/Mainpage/types';

type AllSubjectAreasTreeSelectorProps = {
  subjectsState: TextbookSearchSubjectsType;
  treeSelectorStringState: string;
  setParentState: (value: string) => void;
  disabled?: boolean;
};
export const AllSubjectAreasTreeSelector: FC<AllSubjectAreasTreeSelectorProps> = ({
  treeSelectorStringState,
  disabled,
  setParentState,
  subjectsState,
}) => {
  return (
    <TreeSelect
      value={treeSelectorStringState}
      disabled={disabled}
      treeDefaultExpandAll
      onChange={(value) => setParentState(value)}
      showSearch
    >
      {Object.keys(subjectsState).map((first, fIdx) => (
        <TreeNode
          style={{ fontWeight: '600' }}
          treeIcon
          isLeaf={true}
          selectable={false}
          key={fIdx}
          title={first}
          value={fIdx}
        >
          {Object.keys(subjectsState[first]).map((second) => (
            <TreeNode
              selectable={false}
              isLeaf={true}
              title={second}
              style={{ fontWeight: '600' }}
              key={first + second}
              value={first + second}
            >
              {Object.keys(subjectsState[first][second]).map((third) =>
                third !== '—' ? (
                  <TreeNode
                    selectable={false}
                    title={third}
                    isLeaf={true}
                    style={{ fontWeight: '600' }}
                    key={first + second + third}
                    value={first + second + third}
                  >
                    {Object.keys(subjectsState[first][second][third]).map((fourth) => (
                      <TreeNode
                        isLeaf={true}
                        selectable={false}
                        title={fourth}
                        style={{ fontWeight: '600' }}
                        key={first + second + third + fourth}
                        value={first + second + third + fourth}
                      >
                        {Object.keys(subjectsState[first][second][third][fourth]).map((fifth) => (
                          <TreeNode
                            isLeaf={true}
                            selectable={false}
                            title={fifth}
                            style={{ fontWeight: '600' }}
                            key={first + second + third + fourth + fifth}
                            value={first + second + third + fourth + fifth}
                          >
                            {Object.keys(subjectsState[first][second][third][fourth][fifth]).map((sixth) => (
                              <TreeNode
                                title={sixth}
                                isLeaf={true}
                                key={
                                  subjectsState[first][second][third][fourth][fifth][sixth] +
                                  '[unique]' +
                                  first +
                                  second +
                                  third +
                                  fourth +
                                  fifth +
                                  '[fUni]' +
                                  sixth
                                }
                                value={
                                  subjectsState[first][second][third][fourth][fifth][sixth] +
                                  '[unique]' +
                                  first +
                                  second +
                                  third +
                                  fourth +
                                  fifth +
                                  '[fUni]' +
                                  sixth
                                }
                              ></TreeNode>
                            ))}
                          </TreeNode>
                        ))}
                      </TreeNode>
                    ))}
                  </TreeNode>
                ) : (
                  Object.keys(subjectsState[first][second][third]).map((fourth) => (
                    <TreeNode
                      isLeaf={true}
                      selectable={false}
                      title={fourth}
                      style={{ fontWeight: '600' }}
                      key={first + second + third + fourth}
                      value={first + second + third + fourth}
                    >
                      {Object.keys(subjectsState[first][second][third][fourth]).map((fifth) => (
                        <TreeNode
                          isLeaf={true}
                          selectable={false}
                          title={fifth}
                          style={{ fontWeight: '600' }}
                          key={first + second + third + fourth + fifth}
                          value={first + second + third + fourth + fifth}
                        >
                          {Object.keys(subjectsState[first][second][third][fourth][fifth]).map((sixth) => (
                            <TreeNode
                              title={sixth}
                              isLeaf={true}
                              key={
                                subjectsState[first][second][third][fourth][fifth][sixth] +
                                '[unique]' +
                                first +
                                second +
                                third +
                                fourth +
                                fifth +
                                '[fUni]' +
                                sixth
                              }
                              value={
                                subjectsState[first][second][third][fourth][fifth][sixth] +
                                '[unique]' +
                                first +
                                second +
                                third +
                                fourth +
                                fifth +
                                '[fUni]' +
                                sixth
                              }
                            ></TreeNode>
                          ))}
                        </TreeNode>
                      ))}
                    </TreeNode>
                  ))
                ),
              )}
            </TreeNode>
          ))}
        </TreeNode>
      ))}
    </TreeSelect>
  );
};
